<div [ngClass]="cssClass" class="phone-input-wrapper">
    <div (click)="toggleDropdown()" class="country-selector">
        <img [src]="getFlagUrl(selectedCountry)" alt="{{ selectedCountry }} flag" height="15" width="20">
        <span *ngIf="separateDialCode" class="dial-code">{{ getDialCode(selectedCountry) }}</span>
        <span class="dropdown-arrow">▼</span>
    </div>
    <input (blur)="onBlur()"
           (input)="onInputChange($event)"
           [id]="inputId"
           [placeholder]="getPlaceholder()"
           [value]="displayNumber"
           class="phone-input"
           type="tel">
    <div *ngIf="isDropdownOpen"
         [ngClass]="{'dropdown-top': dropdownPosition === 'top' || (dropdownPosition === 'auto' && isDropdownAbove), 'dropdown-bottom': dropdownPosition === 'bottom' || (dropdownPosition === 'auto' && !isDropdownAbove)}"
         class="dropdown">
        <input (input)="filterCountries()"
               (keydown)="onKeydown($event)"
               [(ngModel)]="searchTerm"
               [attr.aria-activedescendant]="focusedIndex >= 0 ? 'option-' + focusedIndex : null"
               aria-autocomplete="list"
               aria-controls="country-list"
               aria-expanded="isDropdownOpen"
               class="search-input"
               placeholder="Search country">
        <ul id="country-list" role="listbox">
            <ng-container *ngFor="let item of filteredCountries; let i = index">
                <li (click)="selectCountry(item)"
                    *ngIf="item.type === 'country'"
                    [attr.id]="'option-' + i"
                    [class.focused]="i === focusedIndex"
                    role="option">
                    <img [src]="getFlagUrl(item.code)" alt="{{ item.code }} flag" height="15" width="20">
                    {{ item.name }} ({{ item.dialCode }})
                </li>
                <li *ngIf="item.type === 'separator'" class="separator">Other countries</li>
            </ng-container>
            <ng-container *ngIf="filteredCountries.length === 0">
                <li class="no-results">No countries found</li>
            </ng-container>
        </ul>
    </div>
    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
</div>
